import React, { useState } from "react";

type FAQItem = {
  id: number | string;
  question: string;
  answer: string;
};

type AccordionProps = {
  data: FAQItem[];
};

const Accordion: React.FC<AccordionProps> = ({ data }) => {
  const [active, setActive] = useState<number | string | null>(data[0]?.id ?? null);

  const handleClick = (id: number | string) => {
    setActive((prev) => (prev === id ? null : id));
  };

  return (
    <div className="accordion" id="accordionExample">
      {data.map((faq) => (
        <div key={faq.id} className="accordion-item">
          <h6 className="accordion-header" id={`heading${faq.id}`}>
            <button
              className={`accordion-button ${
                active === faq.id ? "" : "collapsed"
              }`}
              type="button"
              onClick={() => handleClick(faq.id)}
              aria-expanded={active === faq.id ? "true" : "false"}
              aria-controls={`collapse${faq.id}`}
            >
              {faq.question}
            </button>
          </h6>
          <div
            id={`collapse${faq.id}`}
            className={`accordion-collapse collapse ${
              active === faq.id ? "show" : ""
            }`}
            aria-labelledby={`heading${faq.id}`}
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">{faq.answer}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
